 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"ea88be26","2":"styles","3":"f1d43c21ad7e070516c8f2c8eb0878e55bec03c1","6":"component---src-components-templates-case-study-index-js","7":"component---src-components-templates-use-case-portfolio-index-js","8":"component---src-pages-404-index-js","9":"component---src-pages-about-index-js","10":"component---src-pages-careers-index-js","11":"component---src-pages-contact-index-js","12":"component---src-pages-index-js","13":"component---src-pages-portfolio-aes-vpp-index-js","14":"component---src-pages-portfolio-bluebenx-index-js","15":"component---src-pages-portfolio-camio-index-js","16":"component---src-pages-portfolio-eqi-index-js","17":"component---src-pages-portfolio-exmox-index-js","18":"component---src-pages-portfolio-findheli-index-js","19":"component---src-pages-portfolio-index-js","20":"component---src-pages-portfolio-lockitron-index-js","21":"component---src-pages-portfolio-lys-index-js","22":"component---src-pages-portfolio-meli-index-js","23":"component---src-pages-portfolio-move-index-js","24":"component---src-pages-portfolio-quiverquantitative-index-js","25":"component---src-pages-portfolio-raimana-index-js","26":"component---src-pages-portfolio-singularity-university-index-js","27":"component---src-pages-portfolio-skyroam-index-js","28":"component---src-pages-portfolio-sodexo-index-js","29":"component---src-pages-portfolio-swfast-index-js","30":"component---src-pages-portfolio-tapcart-index-js","31":"component---src-pages-portfolio-thaw-index-js","32":"component---src-pages-portfolio-woovit-index-js","33":"component---src-pages-services-android-app-development-index-js","34":"component---src-pages-services-blockchain-index-js","35":"component---src-pages-services-dedicated-teams-index-js","36":"component---src-pages-services-mobile-app-development-index-js","37":"component---src-pages-services-nearshore-software-development-company-index-js","38":"component---src-pages-services-nearshore-software-development-index-js","39":"component---src-pages-services-product-definition-index-js","40":"component---src-pages-services-web-app-development-index-js"}[chunkId]||chunkId) + "-" + {"0":"5b81f8fdc6a335d93aea","1":"737ee93b3c2468ebcc74","2":"7d4153d260c0197f0043","3":"d0f2a61e0fc3a0bb9109","6":"3f22caeba78707617553","7":"f10ee553c6e694bcdc63","8":"dd6d48fc4a2e23e147ff","9":"8c7b0822dfbaac65dff2","10":"5b9248d1cae6346dcb6d","11":"35ef421dfb70e8daadd9","12":"d3e055400cd271804e4f","13":"e5e0ed776c4236dbfd67","14":"7c13298409cdfaa679b0","15":"9bcdea18a22347c9e849","16":"05126a0a051ace7c745a","17":"8b62f1b7fed68d2b0fc3","18":"68586a3e9a7229c51dbc","19":"c7dd653acfffc9b2d7f2","20":"c4abc78dd038a26e04b9","21":"c929fa0b20fb4b650437","22":"f2a977c5aa162685f5c3","23":"6f6b27c2bcec7eeefd7c","24":"2141dc798f980c64cebb","25":"01647564154003ea6f9c","26":"e75310c3ce37d8150d4e","27":"d1079cafb7c8f7c48fab","28":"f0495bdeb32ceac401f4","29":"e8c217b40bf9545e7239","30":"95250d802ad539798802","31":"f3029434cc9b013a7b6e","32":"4515f74beb2514da07a6","33":"eddaf854b30d538c0d8a","34":"0d8cc3273d463cf76025","35":"7d4634b2eac5c080ffd4","36":"a2c54fe47b0f12f76e37","37":"707b42c93dd77e5d619e","38":"6fcc92e932a179d1e465","39":"c85a25a6156303c949aa","40":"e81f689147ba55080fbd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"ea88be26","2":"styles","3":"f1d43c21ad7e070516c8f2c8eb0878e55bec03c1","6":"component---src-components-templates-case-study-index-js","7":"component---src-components-templates-use-case-portfolio-index-js","8":"component---src-pages-404-index-js","9":"component---src-pages-about-index-js","10":"component---src-pages-careers-index-js","11":"component---src-pages-contact-index-js","12":"component---src-pages-index-js","13":"component---src-pages-portfolio-aes-vpp-index-js","14":"component---src-pages-portfolio-bluebenx-index-js","15":"component---src-pages-portfolio-camio-index-js","16":"component---src-pages-portfolio-eqi-index-js","17":"component---src-pages-portfolio-exmox-index-js","18":"component---src-pages-portfolio-findheli-index-js","19":"component---src-pages-portfolio-index-js","20":"component---src-pages-portfolio-lockitron-index-js","21":"component---src-pages-portfolio-lys-index-js","22":"component---src-pages-portfolio-meli-index-js","23":"component---src-pages-portfolio-move-index-js","24":"component---src-pages-portfolio-quiverquantitative-index-js","25":"component---src-pages-portfolio-raimana-index-js","26":"component---src-pages-portfolio-singularity-university-index-js","27":"component---src-pages-portfolio-skyroam-index-js","28":"component---src-pages-portfolio-sodexo-index-js","29":"component---src-pages-portfolio-swfast-index-js","30":"component---src-pages-portfolio-tapcart-index-js","31":"component---src-pages-portfolio-thaw-index-js","32":"component---src-pages-portfolio-woovit-index-js","33":"component---src-pages-services-android-app-development-index-js","34":"component---src-pages-services-blockchain-index-js","35":"component---src-pages-services-dedicated-teams-index-js","36":"component---src-pages-services-mobile-app-development-index-js","37":"component---src-pages-services-nearshore-software-development-company-index-js","38":"component---src-pages-services-nearshore-software-development-index-js","39":"component---src-pages-services-product-definition-index-js","40":"component---src-pages-services-web-app-development-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"aad65a13c4c58e9f9521","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
